// src/Components/Category/Category.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Category.css";

const FIVE_MINUTES = 5 * 60 * 1000;
const ALL_ITEMS_ID = "ALL_ITEMS";

export default function Category({ stallId, selected, onSelect }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (stallId && !selected) {
      onSelect(ALL_ITEMS_ID);
    }
  }, [stallId, selected, onSelect]);

  useEffect(() => {
    if (!stallId) return;

    const CACHE_KEY = `categories_${stallId}`;

    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `https://fliplyn-b-c.fly.dev/categories/stall/${stallId}`
        );

        const fetched = Array.isArray(response.data)
          ? response.data
          : [];

        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            data: fetched,
            timestamp: Date.now(),
          })
        );

        setCategories(fetched);
      } catch (error) {
        console.error("❌ Error fetching categories:", error);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    const loadFromCache = () => {
      const cached = localStorage.getItem(CACHE_KEY);

      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          const fresh = Date.now() - parsed.timestamp < FIVE_MINUTES;

          if (fresh && Array.isArray(parsed.data)) {
            setCategories(parsed.data);
            setLoading(false);
            return;
          }
        } catch {}
      }

      fetchCategories();
    };

    loadFromCache();

    const interval = setInterval(fetchCategories, FIVE_MINUTES);
    return () => clearInterval(interval);

  }, [stallId]);

  if (loading) {
    return (
      <div className="category-sidebar category-state">
        Loading categories…
      </div>
    );
  }

  return (
    <div className="category-sidebar">

      {/* ---------------- ALL ITEMS ---------------- */}
      <div
        className={`category-item ${
          selected === ALL_ITEMS_ID ? "active" : ""
        }`}
        onClick={() => onSelect(ALL_ITEMS_ID)}
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/3721/3721842.png"
          alt="All Items"
          className="category-image"
        />
        <span>All Items</span>
      </div>

      {/* ---------------- EMPTY STATE ---------------- */}
      {categories.length === 0 ? (
        <div className="category-empty">
          <p>No categories available</p>
        </div>
      ) : (
        categories.map((cat) => (
          <div
            key={cat.id}
            className={`category-item ${
              selected === cat.id ? "active" : ""
            }`}
            onClick={() => onSelect(cat.id)}
          >
            <img
              src={cat.image_url}
              alt={cat.name}
              className="category-image"
            />
            <span>{cat.name}</span>
          </div>
        ))
      )}
    </div>
  );
}
